/**
 * 作业 / 考试 / 作业单的「学科」选项(2026-10-13 review,李婷婷作业学科串错)。
 *
 * 以前默认取「我的学科」里按名字排第一个的,和班级开什么课无关;多学科老师、主任不改下拉
 * 就会记到别的学科上。现在:
 *   - 选项 = 这个行政班当前学期开的课(我能看到的),班里还没建课程时才回落「我的学科」;
 *   - 默认值只在没有歧义时给:我教的课里恰好一门,或者总共只有一门;否则留空,要老师明确选。
 */
import { useMemo } from "react";

import { useLessonSubjects } from "@/api/lessons";
import { useMyEmployees } from "@/pages/workbench/EmployeeSwitcher";

export interface SubjectChoice {
  slug: string;
  subject_id: string | null;
  name: string;
  mine: boolean;
}

export function useClassSubjectChoice(classId: string) {
  const courses = useLessonSubjects(classId);
  const { employees, loading } = useMyEmployees();
  return useMemo(() => {
    const mineSlugs = new Set(employees.map((e) => e.slug));
    let options: SubjectChoice[];
    if (courses.data && courses.data.length > 0) {
      const seen = new Set<string>();
      options = [];
      for (const c of courses.data) {
        if (seen.has(c.slug)) continue; // 同一学科的几个分层只列一次
        seen.add(c.slug);
        options.push({ slug: c.slug, subject_id: c.subject_id ?? null, name: c.name, mine: mineSlugs.has(c.slug) });
      }
      options.sort((a, b) => Number(b.mine) - Number(a.mine));
    } else {
      options = employees.map((e) => ({ slug: e.slug, subject_id: e.subject_id, name: e.name, mine: true }));
    }
    const mine = options.filter((o) => o.mine);
    const defaultChoice = mine.length === 1 ? mine[0] : options.length === 1 ? options[0] : null;
    return { options, defaultChoice, loading: courses.isLoading || loading };
  }, [courses.data, courses.isLoading, employees, loading]);
}
